// SHOULD MATCH IN FE AND API REPOS
import { z } from 'zod';

export type Dealer = z.infer<typeof DealerSchema>;

export enum DealerEmailTemplate {
  Default = 'default',
  ExoticsCars = 'exotics-cars-template',
  GatewayClassicCars = 'gateway-classic-cars-template',
  PcInvestments = 'pc-investments-template',
}

export const DealerProfileFileSchema = z.object({
  fileName: z.string(),
  fileUrl: z.string(),
  publicUrl: z.string().optional(),
  uploadedBy: z.string().optional(),
  uploadedBySub: z.string().optional(),
  uploadedAt: z.number().optional(),
});

export type DealerProfileFile = z.infer<typeof DealerProfileFileSchema>;

export const DealerSchema = z.object({
  id: z.string(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  isArchived: z.boolean().optional(),

  companyName: z.string().min(2),
  bankName: z.string().optional(),
  phone: z.string(),
  websiteUrl: z.string().optional(),
  emailAddresses: z.array(z.string()),
  customThemeContent: z.string().optional(),
  emailTemplate: z.nativeEnum(DealerEmailTemplate),
  address: z.object({
    addressLine1: z.string(),
    addressLine2: z.string().optional(),
    city: z.string(),
    state: z.string(),
    zipCode: z.string(),
  }),
  documents: z.array(DealerProfileFileSchema).default([]),
});
